
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { computed, reactive, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import Alert from '@/components/elements/Alert.vue'
import Tab from '@/components/elements/Tab.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import HospitalCassetteSimple from '@/components/block/HospitalCassetteSimple.vue'
import NothingArea from '@/components/block/NothingArea.vue'
import BackTo from '@/components/block/BackTo.vue'
import { mypageTabItems } from '@/utils/commonDataset'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'mypageVisitApplicationList',

  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    items_s: {
      type: Object,
      default: () => ({})
    },
    items_reco: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: true
    }
  },

  components: {
    Alert,
    Tab,
    HeadingLv1,
    MypageContents,
    TabSeminar,
    HospitalCassetteSimple,
    NothingArea,
    BackTo,
    Loader
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const tab = reactive({
      list: mypageTabItems,
      current: 1
    })

    const clickTab = (i: number) => {
      router.push({ path: tab.list[i].link })
    }

    const tabSeminar = computed(() => {
      return [
        {
          label: '病院・初期研修',
          name: 'first'
        },
        {
          label: '専門研修',
          name: 'second'
        }
      ]
    })

    const judgeCurrentTabSeminar = () => {
      const index = Number(route.query.tab)
      if (index) {
        return index > 0 ? index : 0
      }
      return store.state.userInfo.member_type === '医学生' ? 0 : 1
    }

    const state = reactive<any>({
      currentTabSeminar: judgeCurrentTabSeminar()
    })

    const clickTabSeminar = (i: number) => {
      state.currentTabSeminar = i
    }

    return {
      tab,
      clickTab,
      tabSeminar,
      state,
      clickTabSeminar,
      judgeCurrentTabSeminar
    }
  }
})
